import React from 'react';
import ReactDOM from 'react-dom/client';
import { EntryPoint } from './EntryPoint';
// Same order as apps/student and apps/manager: this app's own CSS, then the library's stylesheet,
// then the UnoCSS utilities last so they win over both.
//
// index.scss carries the whole colour scheme as CSS custom properties AND the Tailwind-v3
// preflight, so it is also the reset — no separate @unocss/reset is needed (presetUno's own
// preflight only emits `--un-*` defaults).
import './main.css';
import '@ael/shared-components-library/src/index.scss';
import 'uno.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <EntryPoint />
  </React.StrictMode>
);
